
const initialState = {
    STL_List_Items: [],
    openDialog_STL: false,
    openDialog_Material: false,
    dialogIndex: 0,
    stlBounds: [0, 0, 0, 0, 0, 0],
}

const colors = new Map([ //Random Colors for every material
    ['', '#DCDCDC'],
    ['Ac', '#073F8D'],
    ['Ag', '#66599C'],
    ['Al', '#4D1446'],
    ['Am', '#8E0028'],
    ['Ar', '#BE0018'],
    ['As', '#F29808'],
    ['At', '#B0C607'],
    ['Au', '#499F1E'],
    ['B', '#118790'],
    ['Ba', '#0A4F52'],
    ['Be', '#FFEC0A'],
    ['Bi', '#D90053'],
    ['Bk', '#7DABDE'],
    ['Br', '#AEA4CE'],
    ['C', '#97708C'],
    ['Ca', '#C07674'],
    ['Cd', '#DE8266'],
    ['Ce', '#D9E388'],
    ['Cf', '#ABCF86'],
    ['Cl', '#78C2C4'],
    ['Cm', '#78C2C4'],
    ['Co', '#FFF58A'],
    ['Cr', '#EB89A2'],
    ['Cs', '#EB89A2'],
    ['Cu', '#073F8D'],
    ['Dy', '#66599C'],
    ['Er', '#4D1446'],
    ['Eu', '#8E0028'],
    ['F', '#BE0018'],
    ['Fe', '#F29808'],
    ['Fr', '#B0C607'],
    ['Ga', '#499F1E'],
    ['Gd', '#118790'],
    ['Ge', '#0A4F52'],
    ['H', '#FFEC0A'],
    ['He', '#D90053'],
    ['Hf', '#7DABDE'],
    ['Hg', '#AEA4CE'],
    ['Ho', '#97708C'],
    ['I', '#C07674'],
    ['In', '#DE8266'],
    ['Ir', '#FBCB7D'],
    ['K', '#D9E388'],
    ['Kr', '#ABCF86'],
    ['La', '#78C2C4'],
    ['Li', '#78C2C4'],
    ['Lu', '#FFF58A'],
    ['Mg', '#EB89A2'],
    ['Mn', '#EB89A2'],
    ['Mo', '#073F8D'],
    ['N', '#66599C'],
    ['Na', '#4D1446'],
    ['Nb', '#8E0028'],
    ['Nd', '#BE0018'],
    ['Ne', '#F29808'],
    ['Ni', '#B0C607'],
    ['Np', '#499F1E'],
    ['O', '#118790'],
    ['Os', '#0A4F52'],
    ['P', '#FFEC0A'],
    ['POM', '#D90053'],
    ['Pa', '#7DABDE'],
    ['Pb', '#AEA4CE'],
    ['Pd', '#97708C'],
    ['Pm', '#C07674'],
    ['Po', '#DE8266'],
    ['Pr', '#FBCB7D'],
    ['Pt', '#D9E388'],
    ['Pu', '#ABCF86'],
    ['Ra', '#78C2C4'],
    ['Rb', '#78C2C4'],
    ['Re', '#FFF58A'],
    ['Rh', '#EB89A2'],
    ['Rn', '#EB89A2'],
    ['Ru', '#073F8D'],
    ['S', '#66599C'],
    ['Sb', '#4D1446'],
    ['Sc', '#8E0028'],
    ['Se', '#BE0018'],
    ['Si', '#F29808'],
    ['Sm', '#B0C607'],
    ['Sn', '#499F1E'],
    ['Sr', '#118790'],
    ['Ta', '#0A4F52'],
    ['Tb', '#FFEC0A'],
    ['Tc', '#D90053'],
    ['Te', '#7DABDE'],
    ['Th', '#AEA4CE'],
    ['Ti', '#97708C'],
    ['Tm', '#C07674'],
    ['U', '#DE8266'],
    ['V', '#FBCB7D'],
    ['W', '#D9E388'],
    ['Xe', '#ABCF86'],
    ['Y', '#78C2C4'],
    ['Yb', '#78C2C4'],
    ['Zn', '#FFF58A'],
    ['Zr', '#EB89A2'],
  ]);



//-----------------------------------------------------------------



const reducer = (state = initialState, action) => {
    switch (action.type) {

        case "STL_LIST:ADD_ITEM":

            {
                return { 
                    ...state, 
                    STL_List_Items: [
                       ...state.STL_List_Items,
                       {STLFilePath: action.value.STLFilePath, STLFileName: action.value.STLFileName, material: action.value.material, color: colors.get(action.value.material)}
                      ]
                 }
            }

        case "STL_LIST:REMOVE_ITEM":

            {

                let i = 0;
                for(; i < state.STL_List_Items.length; i++)
                    if (state.STL_List_Items[i].STLFilePath == action.value.STLFilePath &&
                        state.STL_List_Items[i].material == action.value.material)
                        break;
                        

                return { 
                    ...state, 
                    STL_List_Items: [
                        ...state.STL_List_Items.slice(0, action.value.index),
                        ...state.STL_List_Items.slice(action.value.index + 1),
                      ]
                 }

            }

        case "STL_LIST:UPDATE_ITEM":

            {

                return { 
                    ...state, 
                    STL_List_Items: state.STL_List_Items.map(
                        (content, i) => i === action.value.index ? {...content, STLFilePath: action.value.STLFilePath, STLFileName: action.value.STLFileName, material: action.value.material, color: colors.get(action.value.material)}
                                                : content
                    )
                 }

            }

        case "STL_LIST:DIALOG_OPEN_STL":

            return Object.assign({}, state, {
                openDialog_STL: true,
                dialogIndex: action.value
            });

        case "STL_LIST:DIALOG_CLOSE_STL":

            return Object.assign({}, state, {
                openDialog_STL: false,
                dialogIndex: action.value
            });

        case "STL_LIST:DIALOG_OPEN_MATERIAL":

            return Object.assign({}, state, {
                openDialog_Material: true,
                dialogIndex: action.value
            });

        case "STL_LIST:DIALOG_CLOSE_MATERIAL":

            return Object.assign({}, state, {
                openDialog_Material: false,
                dialogIndex: action.value
            });

        case "STL:BOUNDS":

            return Object.assign({}, state, {
                stlBounds: action.value
            });

        default:
            return state;
    }
}

export { reducer }
